export default __webpack_public_path__ + "static/media/5.b937e3a0.mp3";